export default "<div class=\"placeholder-animation\"\r\n     [ngStyle]=\"{'height': height, 'width': width}\">\r\n</div>\r\n";